
<div class="card">
  @if (toDisplay) {
    <div class="card-header card-header-squirrel">
      <h4>{{this.translate.data['SUBTITLEGROUPROLEPERMISSIONS'] | translate}}</h4>
      <h4>{{groupRole.name}}</h4>
    </div>
  }
  @if (toDisplay) {
    <div class="card-body">
      @if (data.projectId == null) {
        <div class="col-md-12 d-flex justify-content-end">
          <mat-checkbox color="primary" [(ngModel)]="isForAdmin">Für Projekt Administrator verwenden</mat-checkbox>
        </div>
      }
      <project-permissions-list [projectPermissions]="projectPermissions" [permissions]="groupRole.permissions" (onChangeEvent)="onChange1($event)"></project-permissions-list>
      <!-- <div class="row button-right">
      <a>
        <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;margin-left: 0px" matTooltip="{{this.translate.data['TOOLTIPCLOSEADDUSERDIALOG'] | translate}}"
        (click)="cancel()" >Schließen</button>
      </a>
    </div>        -->
    <div class="row">
      <a>
        <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;margin-left: 0px" matTooltip="{{this.translate.data['TOOLTIPCLOSEADDUSERDIALOG'] | translate}}"
        (click)="cancel()" >Abbruch</button>
      </a>
      <span style="flex: 1 1 auto"></span>
      <a>
        <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;"
          (click)="updatePGR()"  >Speichern
        </button>
        <!-- <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;" matTooltip="{{this.translate.data['ADDNEWPROJECT'] | translate}}"
        (click)="add()" >Hinzufügen
        (click)="updateTGR()"  [disabled]="!isFormValid()">Speichern
      </button> -->
    </a>
  </div>
</div>
}
</div>

